import { useEffect, useState } from 'react';
import api from '@/utils/api';
import { getErrorMessage } from '@/utils/error';
import { BillingSummary } from '../types';

export const useBilling = (shouldFetch: boolean) => {
    const [billing, setBilling] = useState<BillingSummary | null>(null);
    const [isBillingLoading, setIsBillingLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const fetchBillingSummary = async () => {
        try {
            setIsBillingLoading(true);
            setError('');
            const { data } = await api.get<BillingSummary | null | any>('/subscriptions/billing-summary');

            if (data?.status === 'demo') {
                setBilling(null);
                setError('You are on a demo account and do not have an active subscription.');
            } else if (data && Object.keys(data).length === 0) {
                setBilling(null);
            } else {
                setBilling(data);
            }
        } catch (err: unknown) {
            console.error('Failed to fetch billing summary:', err);
            setBilling(null);
            setError(getErrorMessage(err));
        } finally {
            setIsBillingLoading(false);
        }
    };

    useEffect(() => {
        if (shouldFetch) {
            fetchBillingSummary();
        }
    }, [shouldFetch]);

    return {
        billing,
        isBillingLoading,
        error,
        fetchBillingSummary
    };
};
